import { useEffect, useRef } from "react";
import Pages from "../components/Pages";

const BasicLayout = (props) => {
  
    return (
      
        <div className="right-con">
          <Pages />
          <div className="title-wrapper">
            <div className="title" >
              <p className="french">(Dix heures et demie du soir en ete)</p>
              <p className="english">
                Ten-Thirty <br />
                on a Summer Night
              </p>
            </div>
          </div>
          <div className="author">
            <p>Marguerite Duras</p>
          </div>
        </div>
      
    );
  };

  export default BasicLayout;
